import React,{ memo } from 'react'
import AwesomeSlider from 'react-awesome-slider'
import 'react-awesome-slider/dist/styles.css'
import withAutoplay from 'react-awesome-slider/dist/autoplay'

const BannerSlider = () => {
    const AutoplaySlider = withAutoplay(AwesomeSlider)
    const imageArray = [
        {url: 'https://fastui.cltpstatic.com/image/upload/f_auto,q_auto,w_410,h_337,dpr_2/offermgmt/images/slider1.png' },
        {url: 'https://fastui.cltpstatic.com/image/upload/f_auto,q_auto,w_410,h_337,dpr_2/offermgmt/images/slider2.png' },
        {url: 'https://fastui.cltpstatic.com/image/upload/f_auto,q_auto,w_410,h_337,dpr_2/offermgmt/images/slider3.png' }
    ]    

    return (
        <div className="login-banner">
            <AutoplaySlider play interval={2000} transitionDelay={0} organicArrows={false} cancelOnInteraction={false}>
                    {imageArray?.map((item) => (
                           <div className="flex" style={{ backgroundColor: '#FFEEE8'}}>
                                <div className="flex flex-column">
                                    <div className="flex flex-center centered w-100vw m-0 banner-slider-image"
                                        style={{ backgroundColor: '#FFEEE8' }}>

                                        <img width="100%" src={item?.url}/>
                                    </div>
                                </div>
                            </div>
                    ))}
            </AutoplaySlider>
        </div>
    )
}

export default memo(BannerSlider)

